import styled from 'styled-components';
import instagramImg from '../../images/instagram-logo.png';

const S = {}

S.ContactWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;

    & .line-section {
        height: 1px;
        width: 100%;
        margin: 80px 0;
        background: #00000080;
    }
`;

S.ContactCompanySection = styled.section`
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    @media (max-width: 768px) {
            flex-direction: column;
            margin: 0;

            & .company-data, & .availability, & .contact-data {
                margin-bottom: 40px;
            }
    }

    & a {
    display: flex;
    font-size: 18px;
    font-weight: 300;
    line-height: 20px;
    margin-bottom: 10px;
    color: #000;
    text-decoration: none;
    padding: 5px 0;

    @media (max-width: 768px) {
      padding: 16px 0;
      font-size: 18px;
    }

    & svg {
      margin-right: 5px;
    }

    & a {
      text-decoration: none;
      color: #fff;
      font-weight: 600;
    }
  }
    & > div {
        display: flex;
        flex-direction: column;
        flex: 1;
        text-align: center;
        align-items: center;

        & .description {
            margin: 0 50px;
            display: flex;
            flex-direction: column;
            align-items: center;

            /* & .email {
                font-size: 14px;
            } */
            & span {
                margin: 5px 0;
                & svg {
                    margin-right: 5px;
                    & path {
                        fill: #343434;
                    }
                }
            }
        }

        & h3 {
            color: #343434;
            text-transform: uppercase;
            font-weight: 300;
            font-family: Roboto, sans-serif;
            font-weight: 500;
            position: relative;
            padding-left: 30px;
            & ::before {
                content: '';
                position: absolute;
                top: 50%;
                width: 0;
                height: 0;
                border-top: 10px solid transparent;
                border-left: 20px solid #00000080;
                border-bottom: 10px solid transparent;
                margin-right: 5px;
                left: 0;
                transform: translateY(-50%);
            }
        }
        
    }

    & .availability {
        & .open-hours-wrapper {
            margin-left: 30px;
            width: fit-content;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        & span {
            font-size: 18px;
            text-align: center;
        }
    }
`;

S.ContactSocialSection = styled.section`
    display: flex;
    flex-direction: column;
    margin-bottom: 60px;
    & .title {
        text-align: center;
        color: #343434;
        font-size: 32px;
        font-weight: 100;
        margin-bottom: 10px;
        margin: 0 15px;
    }
    & .sm-wrapper {
        & ul {
            display: flex;
            list-style-type: none;
            padding: 0;
            align-items: center;
            justify-content: center;
            & li {
                & a {
                    padding: 10px 20px;
                    font-size: 48px;
                    display: flex;
                    width: 48px;
                    height: 48px;

                    & .instagram-img {
                        height: 48px;
                        width: 48px;
                        border: none;
                        margin: auto 0;
                        background-image: url(${instagramImg});
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
                & .youtube {
                    color: #c4302b;
                }
                & .facebook {
                    color: #3b5998;
                }
                & .instagram {
                    position: relative;
                }

                & .tooltip {
                    position: relative;

                    & :hover {
                        & .tooltip-text {
                            visibility: visible;
                            opacity: 1;
                        }
                    }
                    & .tooltip-text {
                        display: flex;
                        visibility: hidden;
                        width: 120px;
                        background-color: #555;
                        color: #fff;
                        text-align: center;
                        border-radius: 6px;
                        padding: 5px 10px;
                        position: absolute;
                        z-index: 1;
                        top: 100%;
                        left: 50%;
                        margin-left: -70px;
                        opacity: 0;
                        transition: opacity 0.3s;
                        font-size: 12px;

                        & ::after {
                            content: "";
                            position: absolute;
                            bottom: 100%;
                            left: 50%;
                            margin-left: -5px;
                            border-width: 5px;
                            border-style: solid;
                            border-color: transparent transparent #555 transparent;
                        }
                    }
                }
            }
        }
    }
`;

export default S;